// Opening photos (§8): a folder (File System Access, read/write), a remembered or dropped folder, or
// files via <input> in fallback mode. Everything ends in persist.openFolder().
import {
  FallbackFolder,
  FsaFolder,
  ensurePermission,
  hasFsa,
  pickFilesFallback,
  pickFolder,
  rememberFolder,
  type RecentFolder,
} from './fs';
import { openFolder, flushSidecars } from '../state/persist';
import { toLibraryPhotos, useLibrary } from '../state/library';
import { isAcceptedName } from './decode/types';

export async function openFsaFolder(folder: FsaFolder) {
  await flushSidecars();
  await openFolder(folder);
  await rememberFolder(folder);
}

export async function openPhotos(): Promise<void> {
  if (hasFsa()) {
    const f = await pickFolder();
    if (f) await openFsaFolder(f);
    return;
  }
  const files = await pickFilesFallback();
  if (files.length) {
    await flushSidecars();
    await openFolder(new FallbackFolder(files));
  }
}

export async function openRecent(r: RecentFolder): Promise<boolean> {
  if (!(await ensurePermission(r.handle))) return false;
  await openFsaFolder(new FsaFolder(r.handle));
  return true;
}

/** M3 helper kept for tests: open loose files without a folder (no sidecars are written). */
export function loadFiles(files: File[], folderName: string | null) {
  useLibrary.getState().setPhotos(toLibraryPhotos(files.filter((f) => isAcceptedName(f.name))), folderName);
}
